import { DeleteOutline } from '@material-ui/icons';
import { Pagination } from '@material-ui/lab';
import {
  IconButton,
  LinearProgress,
  Tooltip,
  Typography
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import AddIcon from 'images/icons/signals/addsAndCreates/add.svg';

import { Container, GlobalStyle } from 'styles/general';
import TitleHead from 'components/TitleHead';
import Layout from 'containers/layouts/layout';
import FlagDialog from './dialogs/FlagDialog';
import Environment from 'utils/environments';
import {
  getFilterOptions,
  handleFilterOptions
} from 'utils/handleFilterActions';
import Axios from 'axios';
import ItemsPerPage from 'components/ItemsPerPage';
import PageTitleAndFilter from 'components/PageTitleAndFilter';
import ConfirmModal from 'components/Dialogs/ConfirmModal/ConfirmModal';
import CommonAlert from 'components/CommonAlert/CommonAlert';

const FlagsList = ({ userInfo }) => {
  const environments = Environment(process.env.REACT_APP_ENV);
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const profile = userInfo?.profile[0][0]?.name;
  const isLabelAdmin = profile === 'admin_label';
  const activeRestaurantId = isLabelAdmin
    ? userLocal?.labelId
    : userInfo.companiesActive.id;
  const [filtersChanged, setFiltersChanged] = useState([]);
  const [callSettings, setCallSettings] = useState({
    page: 1,
    totalPages: 0,
    size: 100,
    flags: [],
    numberOfElements: 0,
    loading: true,
    totalElements: 0
  });
  const {
    page,
    size,
    totalPages,
    flags,
    numberOfElements,
    totalElements,
    loading
  } = callSettings;
  const [filterFields, setFilterFields] = useState([
    [
      {
        label: 'Marca',
        filterName: 'flagDescription',
        filterNameSecond: 'flagId',
        placeHolder: 'Selecione...',
        type: 'autoComplete',
        urlPath: `${environments.catalog}/flags`,
        key: 'description',
        optionReference: 'description',
        options: [],
        size: 'large',
        searchByTermMode: true
      }
    ]
  ]);
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const [modalSettings, setModalSettings] = useState([
    { id: 1, name: 'flagDialog', open: false },
    { id: 2, name: 'confirmDialog', flag: null, open: false }
  ]);

  const config = {
    headers: {
      User: `${userLocal?.user}`
    }
  };

  const getFilterHandle = (urlPath, label, key, optionReference) => {
    getFilterOptions(
      urlPath,
      label,
      key,
      filterFields,
      setFilterFields,
      optionReference,
      activeRestaurantId,
      '',
      page
    );
  };

  const handleFilter = (param, value, _, paramSecond) => {
    const hasFilterWithFirstName = filtersChanged?.filter(
      (el) => el?.param === param
    )?.length;
    const hasFilterWithSecondName = filtersChanged?.filter(
      (el) => el?.param === paramSecond
    )?.length;

    let formattedFilters = hasFilterWithSecondName
      ? filtersChanged?.filter((el) => el?.param !== paramSecond)
      : filtersChanged;

    if (!value && (hasFilterWithFirstName || hasFilterWithSecondName)) {
      formattedFilters = filtersChanged?.filter(
        (el) => el?.param !== paramSecond && el?.param !== param
      );
    }

    handleFilterOptions(
      param,
      value,
      formattedFilters,
      setFiltersChanged,
      null,
      false,
      '1'
    );
  };

  const handleDelete = async (id) => {
    const baseUrl = `${environments.catalog}/flags`;

    Axios.delete(`${baseUrl}/${id}`, config)
      .then(() => {
        setModalSettings(
          modalSettings.map((modal) =>
            modal.name === 'confirmDialog'
              ? {
                  ...modal,
                  open: false,
                  flag: null
                }
              : modal
          )
        );

        setMessage({
          description: 'Marca removida com sucesso',
          status: 'success'
        });

        getMainContent(page, size);
      })
      .catch((error) => {
        setMessage({
          description: 'Erro ao remover marca',
          status: 'error'
        });
      });
  };

  const getMainContent = async (page, size) => {
    const params = filtersChanged.map((fc) => fc.urlParam).join('&');
    setCallSettings({
      ...callSettings,
      loading: true
    });

    Axios.get(
      `${environments.catalog}/flags?page=${page}&size=${size}&originId=${activeRestaurantId}&${params}`
    )
      .then((response) => {
        setCallSettings({
          ...callSettings,
          totalPages: response?.data?.totalPages,
          flags: response?.data?.content || [],
          numberOfElements: response?.data?.numberOfElements,
          loading: false,
          totalElements: response?.data?.totalElements
        });
      })
      .catch((error) => {
        setMessage({
          description: `Erro ao carregar marcas`,
          status: 'error',
          autoHideDuration: 5000
        });
        setCallSettings({
          ...callSettings,
          loading: false
        });
        console.log(error);
      });
  };

  const addFlag = () => (
    <Tooltip title="Cadastrar marca" aria-label="add">
      <span
        onClick={() => {
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'flagDialog'
                ? { ...modal, open: true, flag: undefined }
                : modal
            )
          );
        }}
      >
        <IconButton
          id="createFlagButton"
          className="p0"
          color="primary"
          aria-label="upload picture"
          component="span"
        >
          <img style={{ width: '25px' }} src={AddIcon} alt="AddIcon" />
        </IconButton>
      </span>
    </Tooltip>
  );

  useEffect(() => {
    setCallSettings({ ...callSettings, page: 1 });
    getMainContent(page, size);
  }, [activeRestaurantId, filtersChanged]);

  useEffect(() => {
    setCallSettings({
      ...callSettings,
      activeRestaurantId
    });
  }, [userInfo]);

  return (
    <Layout>
      <TitleHead title="Marcas" />

      <GlobalStyle />

      <Container>
        <PageTitleAndFilter
          title="Marcas"
          activeFilterFilds={filterFields}
          handleFilter={handleFilter}
          getFilterhandle={getFilterHandle}
          additionalbutton={addFlag}
        />

        <table className="desktop" width="100%" cellPadding="0" cellSpacing="0">
          <thead>
            <tr className="headerTitle">
              <th style={{ width: '23%' }} className="subtitle">
                DESCRIÇÃO
              </th>

              <th style={{ width: '75%' }} className="subtitle pr12 pl12">
                PRODUTOS
              </th>

              <th style={{ width: '2%' }} className="subtitle" />
            </tr>
          </thead>

          {loading && (
            <tr>
              <th colSpan={3} className="m10 textAlignCenter">
                <LinearProgress
                  style={{ height: '7px' }}
                  id="loading"
                  variant="query"
                />
              </th>
            </tr>
          )}

          <tbody>
            {flags?.map((flag) => (
              <>
                <tr key={flag.id}>
                  <td className="p10">
                    <span
                      id="editFlagButton"
                      className="linkElement fontSizeDefault"
                      onClick={() => {
                        setModalSettings(
                          modalSettings.map((modal) =>
                            modal.name === 'flagDialog'
                              ? { ...modal, open: true, flag }
                              : modal
                          )
                        );
                      }}
                    >
                      {flag?.description}
                    </span>
                  </td>

                  <td
                    style={{ borderLeft: 'solid 1px #D0D3E2' }}
                    className="pr12 pl12 fontSizeDefault"
                  >
                    {flag?.productsCount || 0}
                  </td>

                  <td
                    style={{ borderLeft: 'solid 1px #333541' }}
                    className="actionButton"
                  >
                    <Tooltip
                      title="Não é possível excluir marcas que possuam produtos associados"
                      aria-label="add"
                      disableHoverListener={flag?.productsCount === 0}
                    >
                      <IconButton
                        id="deleteFlagButton"
                        className="dFlex mAuto p0"
                        aria-label="delete"
                        onClick={() => {
                          if (flag?.productsCount !== 0) return;
                          
                          setModalSettings(
                            modalSettings.map((modal) =>
                              modal.name === 'confirmDialog'
                                ? {
                                    ...modal,
                                    open: true,
                                    flag
                                  }
                                : modal
                            )
                          );
                        }}
                      >
                        <DeleteOutline />
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>

                <tr>
                  <td colSpan={3}>
                    <hr />
                  </td>
                </tr>
              </>
            ))}

            {!flags?.length ? (
              <tr className="emptyTableLineInfo">
                <th style={{ margin: '10px', textAlign: 'center' }} colSpan={3}>
                  Nenhuma marca encontrada
                </th>
              </tr>
            ) : null}
          </tbody>
        </table>

        <div className="pagination">
          <Pagination
            count={totalPages}
            onChange={(_, page) => {
              setCallSettings({ ...callSettings, page });
              getMainContent(page, size);
            }}
            variant="outlined"
            shape="rounded"
            size="small"
            color="primary"
          />

          <ItemsPerPage
            numberOfElements={numberOfElements}
            size={totalElements}
          />
        </div>

        {modalSettings?.find((modal) => modal?.name === 'flagDialog')?.open ? (
          <FlagDialog
            open={
              !!modalSettings?.find((modal) => modal?.name === 'flagDialog')
                ?.open
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'flagDialog'
                    ? { ...modal, open: false, flag: undefined }
                    : modal
                )
              );
            }}
            flag={
              modalSettings?.find((modal) => modal?.name === 'flagDialog')?.flag
            }
            onSuccess={() => {
              getMainContent(page, size);
            }}
          />
        ) : null}

        {modalSettings.find((modal) => modal.name === 'confirmDialog')
          ?.open && (
          <ConfirmModal
            open={
              modalSettings.find((modal) => modal.name === 'confirmDialog').open
            }
            title={`Deseja realmente excluir ${
              modalSettings.find((modal) => modal.name === 'confirmDialog')
                ?.flag?.description
            }?`}
            content={
              <Typography className="bold">
                Esta ação não pode ser desfeita. Deseja continuar?
              </Typography>
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'confirmDialog'
                    ? {
                        ...modal,
                        open: false,
                        flag: null
                      }
                    : modal
                )
              );
            }}
            cancelText="Não"
            onConfirm={() => {
              handleDelete(
                modalSettings.find((modal) => modal.name === 'confirmDialog')
                  ?.flag?.id
              );

              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'confirmDialog'
                    ? {
                        ...modal,
                        open: false,
                        flag: null
                      }
                    : modal
                )
              );
            }}
            confirmText="Sim"
          />
        )}

        <CommonAlert
          open={!!message?.description}
          severity={message?.status}
          onClose={() => {
            setMessage({
              description: '',
              status: ''
            });
          }}
          messagePersonal={message?.description}
          autoHideDuration={2000}
        />
      </Container>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.user
});

export default connect(mapStateToProps)(FlagsList);
